import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';

const companies = [
  { name: 'Technology Startups' },
  { name: 'Manufacturing Firms' },
  { name: 'Retail Businesses' },
  { name: 'Consulting Agencies' },
  { name: 'Healthcare Clinics' },
  { name: 'Educational Institutes' },
  { name: 'Export & Trading' },
];

const TrustedBy: React.FC = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'white' }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography 
            variant="h4" 
            component="h2"
            sx={{
              fontWeight: 600,
              mb: 2,
              color: 'text.primary',
            }}
          >
            Trusted Across Diverse Industries
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '800px', mx: 'auto' }}>
            We support businesses at every stage with dependable tax and compliance services.
          </Typography>
        </Box>
        
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          {companies.map((company, index) => (
            <Grid 
              item 
              xs={6} 
              sm={4} 
              md={3} 
              lg={2} 
              key={index}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '80px',
                p: 2,
              }}
            >
              <Paper sx={{ px: 2.5, py: 1.5, width: '100%', textAlign: 'center', border: '1px solid', borderColor: 'divider' }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {company.name}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default TrustedBy;
